var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import { Chip, Menu, MenuItem, Typography } from '@mui/material';
import React from 'react';
export const ChipMenu = (props) => {
    var _a, _b;
    const [anchorEl, setAnchorEl] = React.useState();
    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };
    const handleClose = () => {
        setAnchorEl(undefined);
    };
    return (React.createElement(React.Fragment, null,
        React.createElement(Chip, { variant: 'outlined', size: props.size, label: React.createElement(React.Fragment, null,
                React.createElement(Typography, { variant: 'caption', sx: { pr: '20px' } }, props.label),
                React.createElement(ArrowDropDownIcon, { sx: {
                        position: 'absolute',
                        top: 'calc(50% - 10px)',
                        right: '6px',
                        fontSize: 20,
                        transform: anchorEl ? 'rotate(180deg)' : undefined,
                        transition: 'transform 150ms ease-in-out',
                    } })), onClick: handleClick }),
        React.createElement(Menu, { anchorEl: anchorEl, open: !!anchorEl, anchorOrigin: { horizontal: (_a = props.anchor) !== null && _a !== void 0 ? _a : 'left', vertical: 'bottom' }, transformOrigin: { horizontal: (_b = props.anchor) !== null && _b !== void 0 ? _b : 'left', vertical: 'top' }, onClose: handleClose }, props.menuItems.map((_a) => {
            var { onClick } = _a, menuItem = __rest(_a, ["onClick"]);
            return menuItem.href ? (React.createElement("li", { key: menuItem.label },
                React.createElement(MenuItem, { component: 'a', href: menuItem.href, onClick: (event) => {
                        if (onClick) {
                            event.preventDefault();
                            onClick();
                        }
                        handleClose();
                    }, disabled: menuItem.disabled, "data-test": menuItem['data-test'] }, menuItem.label))) : (React.createElement(MenuItem, { key: menuItem.label, onClick: (event) => {
                    if (onClick) {
                        event.preventDefault();
                        onClick();
                    }
                    handleClose();
                }, disabled: menuItem.disabled, "data-test": menuItem['data-test'] }, menuItem.label));
        }))));
};
